




import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import DateRangeStat from "@/components/app/global/stats/_dateRangeStat.vue";

@Component({
  components: {
    DateRangeStat
  }
})
export default class AffiliateTotalPaidOutCommissions extends Vue {
  public $refs!: {
    dateRangeStat: DateRangeStat;
  };

  // Props
  @Prop({ required: true })
  public readonly dateFrom!: Date;

  @Prop({ required: true })
  public readonly dateTo!: Date;

  @Prop({ default: null })
  public currencyCode!: string;

  @Watch("currencyCode")
  public onCurrencyCodeChange() {
    this.$refs?.dateRangeStat.recalculateStatValue();
  }

  public get attrs() {
    return this.$_.merge(
      {
        dataModule: DataModules.AFFILIATES_STATS,
        id: "affiliateStats",
        label: this.$t("_.paid_out"),
        scope: "affiliateStats",
        params: {},
        valuePath: ``,
        valueFunc: ({ data, defaultValue }) => {
          return this.$_.get(
            data,
            `${this.currencyCode}.payout_total_formatted`,
            defaultValue
          );
        },
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        currencyBound: false
      },
      this.$attrs
    );
  }
}
